<template>
  <div class="">
      <div class="text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden">
        <div class="bg-theme-green px-4 py-2 text-white">
          <div class="flex justify-between items-center">
            <h2 class="font-semibold truncate text-single-line break-all leading-tight text-2xl mt-0 mr-2">{{ form.name.value ? form.name.value : 'New Holiday'}}</h2>
            <div class="flex items-center content-center">
              <button @click="addNew()" class=" cursor-pointer bg-white py-2 px-4 rounded text-theme-green hover:bg-theme-darkgreen hover:text-white ml-3">
                  <span>SAVE</span>
              </button>
              <span @click.prevent="clearComponent" class="cursor-pointer rounded-md  text-white py-2 pl-2  hover:opacity-70">CLOSE</span>
              <!-- <mdicon @click.prevent="clearComponent" size="32" name="close" class="cursor-pointer hover:opacity-60 text-4xl ml-4"/> -->
            </div>
          </div>
        </div>


        <div class="pt-3 bg-[#2B2C32] px-[16px] py-[16px] rounded-lg">
          
          <div class="flex gap-3 xl:flex-row flex-col items-start mb-3">
              <div class="w-full xl:w-4/5">
                  <div :class="'input-wrapper ' + (form.name.error_type)">
                      <label class="text-xs mb-1">Name</label>
                      <input v-model="form.name.value" @keyup="validateFields(['name'])" placeholder="May the Fourth" class="block border-none rounded bg-gray-black w-full text-sm text-theme-white placeholder-gray-100::placeholder" type="text">
                      <p class="field-error label-text mt-1" v-if="form.name.error_message" v-text="form.name.error_message"></p>
                  </div>
              </div>
               <div class="w-full xl:w-1/5">
                  <div class="input-wrapper">
                      <label class="text-xs mb-1">Active</label>
                      <label class="flex items-center cursor-pointer mt-1">
                        <input type="checkbox" v-model="form.isActive" class="hidden peer">
                        <div :class="'relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (form.isActive ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]')"></div>
                      </label>
                  </div>
              </div>
          </div>

          <div class="flex gap-3 xl:flex-row flex-col items-start mb-3">
              <div class="w-full">
                  <div :class="'input-wrapper ' + (form.message.error_type)">
                      <label class="text-xs mb-1">Description</label>
                      <textarea @keyup="validateFields(['message'])" v-model="form.message.value" placeholder="May the Fourth be with you!" class="block border-none rounded bg-gray-black w-full h-[70px] text-sm text-theme-white placeholder-gray-100::placeholder"></textarea>
                      <p class="field-error label-text mt-1" v-if="form.message.error_message" v-text="form.message.error_message"></p>
                  </div>
              </div>
          </div>

          <div class="flex gap-2 xl:flex-row flex-col pb-2">
            <div class="xl:w-1/2 w-full">
                <div :class="'input-wrapper clearable ' + (form.startDate.error_type)">
                    <label class="text-xs mb-1">Start Date</label>
                    <div class="block bg-gray-black rounded w-full flex items-center">
                      <span class="ml-2 mr-2">
                        <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9 12C8.71667 12 8.47917 11.9042 8.2875 11.7125C8.09583 11.5208 8 11.2833 8 11C8 10.7167 8.09583 10.4792 8.2875 10.2875C8.47917 10.0958 8.71667 10 9 10C9.28333 10 9.52083 10.0958 9.7125 10.2875C9.90417 10.4792 10 10.7167 10 11C10 11.2833 9.90417 11.5208 9.7125 11.7125C9.52083 11.9042 9.28333 12 9 12ZM5 12C4.71667 12 4.47917 11.9042 4.2875 11.7125C4.09583 11.5208 4 11.2833 4 11C4 10.7167 4.09583 10.4792 4.2875 10.2875C4.47917 10.0958 4.71667 10 5 10C5.28333 10 5.52083 10.0958 5.7125 10.2875C5.90417 10.4792 6 10.7167 6 11C6 11.2833 5.90417 11.5208 5.7125 11.7125C5.52083 11.9042 5.28333 12 5 12ZM13 12C12.7167 12 12.4792 11.9042 12.2875 11.7125C12.0958 11.5208 12 11.2833 12 11C12 10.7167 12.0958 10.4792 12.2875 10.2875C12.4792 10.0958 12.7167 10 13 10C13.2833 10 13.5208 10.0958 13.7125 10.2875C13.9042 10.4792 14 10.7167 14 11C14 11.2833 13.9042 11.5208 13.7125 11.7125C13.5208 11.9042 13.2833 12 13 12ZM9 16C8.71667 16 8.47917 15.9042 8.2875 15.7125C8.09583 15.5208 8 15.2833 8 15C8 14.7167 8.09583 14.4792 8.2875 14.2875C8.47917 14.0958 8.71667 14 9 14C9.28333 14 9.52083 14.0958 9.7125 14.2875C9.90417 14.4792 10 14.7167 10 15C10 15.2833 9.90417 15.5208 9.7125 15.7125C9.52083 15.9042 9.28333 16 9 16ZM5 16C4.71667 16 4.47917 15.9042 4.2875 15.7125C4.09583 15.5208 4 15.2833 4 15C4 14.7167 4.09583 14.4792 4.2875 14.2875C4.47917 14.0958 4.71667 14 5 14C5.28333 14 5.52083 14.0958 5.7125 14.2875C5.90417 14.4792 6 14.7167 6 15C6 15.2833 5.90417 15.5208 5.7125 15.7125C5.52083 15.9042 5.28333 16 5 16ZM13 16C12.7167 16 12.4792 15.9042 12.2875 15.7125C12.0958 15.5208 12 15.2833 12 15C12 14.7167 12.0958 14.4792 12.2875 14.2875C12.4792 14.0958 12.7167 14 13 14C13.2833 14 13.5208 14.0958 13.7125 14.2875C13.9042 14.4792 14 14.7167 14 15C14 15.2833 13.9042 15.5208 13.7125 15.7125C13.5208 15.9042 13.2833 16 13 16ZM1.5 20C1.1 20 0.75 19.85 0.45 19.55C0.15 19.25 0 18.9 0 18.5V3C0 2.6 0.15 2.25 0.45 1.95C0.75 1.65 1.1 1.5 1.5 1.5H3.125V0H4.75V1.5H13.25V0H14.875V1.5H16.5C16.9 1.5 17.25 1.65 17.55 1.95C17.85 2.25 18 2.6 18 3V18.5C18 18.9 17.85 19.25 17.55 19.55C17.25 19.85 16.9 20 16.5 20H1.5ZM1.5 18.5H16.5V7.75H1.5V18.5ZM1.5 6.25H16.5V3H1.5V6.25ZM1.5 6.25V3V6.25Z" fill="white"/>
                        </svg>
                      </span>
                      <Datepicker :clearable="true" :inputFormat="'yyyy-MM-dd'" :lowerLimit="new Date()" placeholder="Select a Date" v-model="form.startDate.value" class="focus:border-transparent focus:ring-0 bg-gray-black border-0 w-full"/>
                    </div>
                    <p class="field-error label-text mt-1" v-if="form.startDate.error_message" v-text="form.startDate.error_message"></p>
                </div>
            </div>
            <div class="xl:w-1/2 w-full">
                <div :class="'input-wrapper clearable ' + (form.endDate.error_type)">
                    <label class="text-xs mb-1">End Date</label>
                    <div class="block bg-gray-black rounded w-full flex items-center">
                        <span class="ml-2 mr-2">
                          <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 12C8.71667 12 8.47917 11.9042 8.2875 11.7125C8.09583 11.5208 8 11.2833 8 11C8 10.7167 8.09583 10.4792 8.2875 10.2875C8.47917 10.0958 8.71667 10 9 10C9.28333 10 9.52083 10.0958 9.7125 10.2875C9.90417 10.4792 10 10.7167 10 11C10 11.2833 9.90417 11.5208 9.7125 11.7125C9.52083 11.9042 9.28333 12 9 12ZM5 12C4.71667 12 4.47917 11.9042 4.2875 11.7125C4.09583 11.5208 4 11.2833 4 11C4 10.7167 4.09583 10.4792 4.2875 10.2875C4.47917 10.0958 4.71667 10 5 10C5.28333 10 5.52083 10.0958 5.7125 10.2875C5.90417 10.4792 6 10.7167 6 11C6 11.2833 5.90417 11.5208 5.7125 11.7125C5.52083 11.9042 5.28333 12 5 12ZM13 12C12.7167 12 12.4792 11.9042 12.2875 11.7125C12.0958 11.5208 12 11.2833 12 11C12 10.7167 12.0958 10.4792 12.2875 10.2875C12.4792 10.0958 12.7167 10 13 10C13.2833 10 13.5208 10.0958 13.7125 10.2875C13.9042 10.4792 14 10.7167 14 11C14 11.2833 13.9042 11.5208 13.7125 11.7125C13.5208 11.9042 13.2833 12 13 12ZM9 16C8.71667 16 8.47917 15.9042 8.2875 15.7125C8.09583 15.5208 8 15.2833 8 15C8 14.7167 8.09583 14.4792 8.2875 14.2875C8.47917 14.0958 8.71667 14 9 14C9.28333 14 9.52083 14.0958 9.7125 14.2875C9.90417 14.4792 10 14.7167 10 15C10 15.2833 9.90417 15.5208 9.7125 15.7125C9.52083 15.9042 9.28333 16 9 16ZM5 16C4.71667 16 4.47917 15.9042 4.2875 15.7125C4.09583 15.5208 4 15.2833 4 15C4 14.7167 4.09583 14.4792 4.2875 14.2875C4.47917 14.0958 4.71667 14 5 14C5.28333 14 5.52083 14.0958 5.7125 14.2875C5.90417 14.4792 6 14.7167 6 15C6 15.2833 5.90417 15.5208 5.7125 15.7125C5.52083 15.9042 5.28333 16 5 16ZM13 16C12.7167 16 12.4792 15.9042 12.2875 15.7125C12.0958 15.5208 12 15.2833 12 15C12 14.7167 12.0958 14.4792 12.2875 14.2875C12.4792 14.0958 12.7167 14 13 14C13.2833 14 13.5208 14.0958 13.7125 14.2875C13.9042 14.4792 14 14.7167 14 15C14 15.2833 13.9042 15.5208 13.7125 15.7125C13.5208 15.9042 13.2833 16 13 16ZM1.5 20C1.1 20 0.75 19.85 0.45 19.55C0.15 19.25 0 18.9 0 18.5V3C0 2.6 0.15 2.25 0.45 1.95C0.75 1.65 1.1 1.5 1.5 1.5H3.125V0H4.75V1.5H13.25V0H14.875V1.5H16.5C16.9 1.5 17.25 1.65 17.55 1.95C17.85 2.25 18 2.6 18 3V18.5C18 18.9 17.85 19.25 17.55 19.55C17.25 19.85 16.9 20 16.5 20H1.5ZM1.5 18.5H16.5V7.75H1.5V18.5ZM1.5 6.25H16.5V3H1.5V6.25ZM1.5 6.25V3V6.25Z" fill="white"/>
                          </svg>
                        </span>
                       <Datepicker :clearable="true" :inputFormat="'yyyy-MM-dd'" :lowerLimit="new Date()" placeholder="Select a Date" v-model="form.endDate.value" class="focus:border-transparent focus:ring-0 bg-gray-black border-0 w-full"/>
                    </div>
                     <p class="field-error label-text mt-1" v-if="form.endDate.error_message" v-text="form.endDate.error_message"></p>
                </div>
            </div>
          </div>

          <div class="bg-theme-borderblack h-1 w-full my-4"></div>

          <template v-if="form.startDate.value && form.endDate.value">
           
            <p v-if="datePickersData.length < 1" class="text-xs font-semibold text-center text-theme-red">End time must be greater than start time.</p>
          
            <div :class="'holiday-activity overflow-y-auto ' + (holidayDates.length > 5 ? 'h-[300px]' : '')" v-else>
            
              <div v-bind:key="day.holidayDate + 'loop'" v-for="(day, index) in holidayDates">
                <div class="flex flex-row justify-between gap-3 mb-2">
                  <div class="w-full xl:w-1/3 h-[65px] flex items-center">
                      <div class="input-wrapper flex justify-between">
                          <label class="flex items-center cursor-pointer mt-5" @click.prevent="day.isOpen = !day.isOpen"> 
                              <div class="mr-2 text-base text-theme-878686 font-semibold">{{ day.holidayDateDisplay }}</div>
                              <input type="checkbox"  class="hidden peer" v-model="day.isOpen">
                              <div :class="'relative toggle-bg  border-2  h-6 w-11 rounded-full mx-2 ' + (day.isOpen ? 'bg-theme-green border-theme-green' : 'bg-theme-red border-theme-red')"></div>
                              <span :class="'ml-2 text-white text-sm font-medium uppercase ' + (day.isOpen ? 'text-theme-green' : 'text-theme-red')">{{day.isOpen ? 'OPEN' : 'CLOSED'}}</span>
                          </label>
                      </div>
                  </div>

                  <div class="w-full xl:w-1/3" >
                      <div :class="'input-wrapper'">
                          <label class="text-xs font-normal mb-1">Start Time</label>
                          <div class="block rounded bg-gray-black w-full relative">
                              <div class="bg-gray-black rounded flex items-center w-full pr-[80px] rounded px-1 py-2">
                                <select @change.prevent="validateStartEndTime(index)" v-model="day.openTime.HH" class="bg-gray-black border-0 focus:border-transparent focus:ring-0 text-sm w-[100px] pl-2 py-0 pr-0 sm-arrow">
                                  <option :value="hour > 9 ? hour : '0'+hour" v-bind:key="hour + 'hour'" v-for="hour in 12">{{ hour > 9 ? hour : '0'+hour }}</option>
                                </select>
                                <span>:</span>
                                <select v-model="day.openTime.MM" @change.prevent="validateStartEndTime(index)" class="bg-gray-black border-0 focus:border-transparent focus:ring-0 text-sm w-[100px] pl-2 py-0 pr-0 sm-arrow">
                                  <option :value="min > 9 ? min : '0'+min" v-bind:key="min + 'min'" v-for="(key, min ) in 60">{{ min > 9 ? min : '0'+min }}</option>
                                </select>
                              </div>
                              <label class="flex items-center cursor-pointer absolute right-1 top-2">
                                  <input type="checkbox" @change.prevent="validateStartEndTime(index)" v-model="day.openTimeTypeAm" class="hidden peer">
                                  <div :class="'relative toggle-bg ampm-inside-switch border-2  h-6 w-[50px] rounded-full ' + (day.openTimeTypeAm ? 'bg-theme-darkgreen border-theme-green' : 'bg-theme-darkgreen  border-theme-green')">
                                      <span :class="'text-white  text-xs leading-loose right-1 ' + (day.openTimeTypeAm ? 'left' : 'right')">{{day.openTimeTypeAm ? 'AM' : 'PM'}}</span>
                                  </div>
                              </label>
                          </div>
                      </div>
                  </div>

                  <div class="w-full xl:w-1/3">
                      <div :class="'input-wrapper'">
                          <label class="text-xs font-normal mb-1">End Time</label>
                          <div class="block rounded bg-gray-black w-full relative">
                            
                            <div class="bg-gray-black rounded flex items-center w-full pr-[80px] rounded py-2">
                                <select v-model="day.closeTime.HH" @change.prevent="validateStartEndTime(index)" class="bg-gray-black border-0 focus:border-transparent focus:ring-0 text-sm w-[100px] pl-2 py-0 pr-0 sm-arrow">
                                  <option :value="hour > 9 ? hour : '0'+hour" v-bind:key="hour + 'hour'" v-for="hour in 12">{{ hour > 9 ? hour : '0'+hour }}</option>
                                </select>
                                <span>:</span>
                                <select v-model="day.closeTime.MM" @change.prevent="validateStartEndTime(index)" class="bg-gray-black focus:border-transparent focus:ring-0 border-0 text-sm w-[100px] py-0 pl-2 pr-0 sm-arrow">
                                  <option :value="min > 9 ? min : '0'+min" v-bind:key="min + 'min'" v-for="(key, min) in 60">{{ min > 9 ? min : '0'+min }}</option>
                                </select>
                              </div>

                              <label class="flex items-center cursor-pointer absolute right-2 top-2">
                                  <input type="checkbox" @change.prevent="validateStartEndTime(index)" v-model="day.closeTimeTypeAm" class="hidden peer">
                                  <div :class="'relative toggle-bg ampm-inside-switch border-2  h-6 w-[50px] rounded-full ' + (day.closeTimeTypeAm ? 'bg-theme-darkgreen border-theme-green' : 'bg-theme-darkgreen  border-theme-green')">
                                    <span :class="'text-white  text-xs leading-loose ' + (day.closeTimeTypeAm ? 'left' : 'right')">{{day.closeTimeTypeAm ? 'AM' : 'PM'}}</span>
                                  </div>
                              </label>
                          </div>
                      </div>
                  </div>
                </div>
                <p v-if="day.is_valid_openTime_closeTime == false" class="text-theme-red w-full text-end text-xs">End time must be greater than start time.</p>
              </div>
            </div>
          </template>
          <!-- <p v-else class="text-sm font-semibold text-center text-theme-878686"> Select holiday dates first</p> -->
        </div>

      </div>
    </div>
</template>


<script lang="ts">
import {defineComponent, ref} from "vue"
import { mapGetters, mapActions, mapMutations } from "vuex";
import LocationHolidayHoursApis from "@/controllers/LocationHolidayHoursApis";
import { useSnackbar } from "vue3-snackbar";
import Helpers from '@/helpers';
 import Datepicker from 'vue3-datepicker'
//import Datepicker from '@vuepic/vue-datepicker';
import moment from 'moment';

export default defineComponent({
  name: "AddLocationHoliday",
  components: {
    Datepicker
  },
  props:{
    clearComponent: {
      type: Function,
      required: true,
    },
  },
  setup() {
    const snackbar = useSnackbar();
    const taxRateTypePercentage = ref(true);
    const picked = ref(new Date())
    const holidayDates = <any>ref([]);
    const form = ref({
      name: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required', 'min:3'],
      },
      message: {
        value: null,
        error_type: '',
        error_message: '',
        validations: ['required', 'min:3'],
      },
      startDate: {
        value: null,
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
      endDate: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
      isActive: false,
    });
    return {
      form,
      snackbar,
      taxRateTypePercentage,
      picked,
      holidayDates
    };
  },

  watch:{
    'form.startDate.value'() {
      this.validateFields(['startDate']);
    },
    'form.endDate.value'() {
      this.validateFields(['endDate']);
    },
  },

  computed: {
    // end date must be greated then start
    datePickersData() {
      let list = <any>[];
      if(this.form.startDate.value && this.form.endDate.value) {
          let startDate = moment(this.form.startDate.value);
          let endDate = moment(this.form.endDate.value);
          let totalDays = endDate.diff(startDate, 'days') + 1;
          if(totalDays > 0){
            for (let day = 0; day < totalDays; day++) {
              // startdate auto update so, first item 0 then all 1
              let theDay = startDate.add( day == 0 ? 0 : 1, 'days');
              list.push({
                day: theDay.day(),
                dayName: theDay.format('dddd'),
                holidayDate: theDay.format('YYYY-MM-DD'),
                holidayDateDisplay: theDay.format('MM/DD'),
                isOpen: true,
                openTime: {
                  HH: '01',
                  MM: '00',
                },
                is_valid_openTime_closeTime: true,
                openTimeTypeAm: true,
                closeTime: {
                  HH: '01',
                  MM: '01',
                },
                closeTimeTypeAm: true
              })
            }
          }
      } 
      this.holidayDates = list;
      return list;
    },

    ...mapGetters({
     
    }),
  },

  mounted() {
     
  },
 
  methods: {
    /**
     * Validate start end time
     */
    async validateStartEndTime(index) {
      this.holidayDates = await Helpers.validateStartEndTime(this.holidayDates, index);
    },
   
     /**
     * Validation captures
     */
    async validateFields(fields) {
      let res = await Helpers.validateFormFields(this.form, fields);
      // capture the fields
      this.form = res.data;
      return res.error ? false : true;
    },


    /**
     * Add new location Tax
     */
    async addNew() {
      let validate = await this.validateFields(['name', 'message', 'startDate', 'endDate']);
      if(!validate) {
        return ;
      }
      // Validate datepicker date before submit
      let startDate = moment(this.form.startDate.value);
      let endDate = moment(this.form.endDate.value);
      let totalDays = endDate.diff(startDate, 'days') + 1;
      if(totalDays < 1){
        return this.snackbar.add({
          type: 'info',
          text: 'End date ' + endDate.format('YYYY-MM-DD') +' must be greater or equals to start date ' + startDate.format('YYYY-MM-DD'),
          duration: 3000,
        })
      }
      // Validate holiday dates must be min 1 
      if(this.datePickersData.length == 0){
        return this.snackbar.add({
          type: 'info',
          text: 'You must have at least 1 holiday hours.',
          duration: 3000,
        })
      }

      // validate holidays date's time must be valid
      
      for (let i = 0; i < this.holidayDates.length; i++) {
        if(this.holidayDates[i].is_valid_openTime_closeTime == false) {
          return this.snackbar.add({
            type: 'info',
            text: 'End time must be greater than start time on ' + this.holidayDates[i].holidayDateDisplay,
            duration: 3000,
          })
        }
      }
      
      this.va_spinner(true);
      let data = <any>Helpers.getFormKeyValue(this.form);
      // now we need to chnage the date values
      data.startDate = moment(data.startDate).format('YYYY-MM-DD');
      data.endDate = moment(data.endDate).format('YYYY-MM-DD');
      data.holidayHours = <any>Helpers.convertLocation12hoursTo24hours(this.holidayDates);
      let res = await LocationHolidayHoursApis.addNewLocationHolidayHours(data);
      this.va_spinner(false);
      this.snackbar.add({
        type: 'info',
        text: res.status == 201 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
        duration: 3000,
      })
      if(res.status == 201 ) {
        this.clearComponent();
        this.emitter.emit("refresh-location-holidays-list", true);
      }
    },

    ...mapActions({
      va_spinner: 'spinner/setSpinner',
    })
  },
});

</script>